import React, { useEffect, useState } from "react";

function App() {
  const [signals, setSignals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  //const API_BASE_URL = 'https://localhost:7215'; // Ajustar al puerto de tu API .NET
  const API_BASE_URL = 'https://ai-bot-api-aizs.onrender.com'; // Ajustar al puerto de tu API .NET


  const fetchSignals = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/Trading/ai-signals?symbols=BTCUSDT,1000PEPEUSDT,SOLUSDT`);
      
      if (!response.ok) throw new Error("Error fetching signals");
      const data = await response.json();
      setSignals(data);
      setLoading(false);
      setError(null);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSignals();
    const interval = setInterval(fetchSignals, 5000);
    return () => clearInterval(interval);
  }, []);

  if (loading) return <p>⏳ Loading signals...</p>;
  if (error) return <p>❌ {error}</p>;

  return (
    <div style={{ padding: 20 }}>
      <h1>🔍 AI Trading Signals</h1>
      {signals.length === 0 && <p>No signals available</p>}
      {signals.map(({ symbol, signal, confidence, price, leverage, stop_loss, take_profit, data }) => (
        <div key={symbol} style={{ border: "1px solid #ddd", marginBottom: 20, padding: 15, borderRadius: 8 }}>
          <h2>{symbol}</h2>
          <p><strong>Price:</strong> ${price.toFixed(4)}</p>
          <p><strong>Signal:</strong> {signal}</p>
          <p><strong>Confidence:</strong> {confidence.toFixed(2)}%</p>
          {data && (
            <>
              <p><strong>RSI:</strong> {data.rsi.toFixed(4)}</p>
              <p><strong>EMA:</strong> {data.ema.toFixed(4)}</p>
              <p><strong>MACD:</strong> {data.macd.toFixed(4)}</p>
            </>
          )}
          {signal === "buy" && leverage && stop_loss !== null && take_profit !== null && (
            <>
              <p>🎯 Leverage: {leverage}x</p>
              <p>🛑 Stop Loss: ${stop_loss.toFixed(4)}</p>
              <p>💰 Take Profit: ${take_profit.toFixed(4)}</p>
            </>
          )}
        </div>
      ))}
    </div>
  );
}

export default App;
